import { useLocation } from 'react-router-dom';

/**
 * 是否 AI 搜索 - 智能体会话
 */
function useIsAiso() {
  const currentLocation = useLocation();
  const isAiso = /^\/aichat/.test(currentLocation.pathname);
  return isAiso;
}

export default useIsAiso;

/**
 * 是否智能体会话
 */
export const useIsAgentChat = () => {
  const currentLocation = useLocation();
  const isAiso = /^\/agentchat/.test(currentLocation.pathname);
  return isAiso;
}

/**
 * 是否大模型会话
 */
export const useIsModelChat = () => {
  const currentLocation = useLocation();
  const isAiso = /^\/chat/.test(currentLocation.pathname);
  return isAiso;
}
